<section>
  <div class="content-2">
    <div class="title-container">
      <h1 class="text-bold text-heading-lg text text-blue-500">Resultado da Projeção de Matrícula</h1>
    </div>
    <div class="mt-4">
      <div class="table-content rounded-sm sm-shadow">

        <!-- Tabela com 6 colunas (feature flag habilitada) -->
        <app-tabela
          *ngIf="exibirCrechePorIdade"
          [cabecalhoCustomizado]="true"
          ngSkipHydration
        >
          <ng-container cabecalho>
            <tr class="header-row">
              <th class="top-left-header text-body-lg">Etapa/Modalidade</th>
              <th class="top-header text-body-lg">Total (Diurno e Noturno)<br><br><span class="ano-censo-label">{{anoCenso}}</span></th>
              <th class="top-header text-body-lg">Matrículas Diurno (parcial e integral)<br><br><span class="ano-censo-label">{{anoCenso}}</span></th>
              <th class="top-header text-body-lg">Matrículas Tempo Integral<br><br><span class="ano-censo-label">{{anoCenso}}</span></th>
              <th class="top-header text-body-lg">% Integral sobre o Total<br><br><span class="ano-censo-label">{{anoCenso}}</span></th>
              <th class="top-right-header text-body-lg">Matrículas Noturno<br><br><span class="ano-censo-label">{{anoCenso}}</span></th>
            </tr>
          </ng-container>
          
          <ng-container corpo>
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-bold">Creche</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasCreche | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasDiurnoCreche | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasIntegralCreche | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ porcentagemIntegralCreche }}</td>
              <td class="right-cell align-left text-body-lg text-bold">{{ totalMatriculasNoturnoCreche | number:'1.0-0':'pt-BR' }}</td>
            </tr>

            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Creche: 0 a 12 meses</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasCrecheMenor1Ano | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasDiurnoCrecheMenor1Ano | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasIntegralCrecheMenor1Ano | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ porcentagemIntegralCrecheMenor1Ano }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ totalMatriculasNoturnoCrecheMenor1Ano | number:'1.0-0':'pt-BR' }}</td>
            </tr>

            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Creche: 12 a 24 meses</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasCreche1Ano | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasDiurnoCreche1Ano | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasIntegralCreche1Ano | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ porcentagemIntegralCreche1Ano }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ totalMatriculasNoturnoCreche1Ano | number:'1.0-0':'pt-BR' }}</td>
            </tr>

            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Creche: 25 a 36 meses</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasCreche2Anos | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasDiurnoCreche2Anos | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasIntegralCreche2Anos | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ porcentagemIntegralCreche2Anos }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ totalMatriculasNoturnoCreche2Anos | number:'1.0-0':'pt-BR' }}</td>
            </tr>

            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Creche: 37 a 48 meses</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasCreche3Anos | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasDiurnoCreche3Anos | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasIntegralCreche3Anos | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-regular">{{ porcentagemIntegralCreche3Anos }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ totalMatriculasNoturnoCreche3Anos | number:'1.0-0':'pt-BR' }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-bold">Pré-escola: 4 e 5 anos</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasPreEscola | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasDiurnoPreEscola | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasIntegralPreEscola | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ porcentagemIntegralPreEscola }}</td>
              <td class="right-cell align-left text-body-lg text-bold">{{ totalMatriculasNoturnoPreEscola | number:'1.0-0':'pt-BR' }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-bold">Ensino Fundamental - anos iniciais</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasEnsinoFundamentalAnosIniciais | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasDiurnoEnsinoFundamentalAnosIniciais | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasIntegralEnsinoFundamentalAnosIniciais | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ porcentagemIntegralEnsinoFundamentalAnosIniciais }}</td>
              <td class="right-cell align-left text-body-lg text-bold">{{ totalMatriculasNoturnoEnsinoFundamentalAnosIniciais | number:'1.0-0':'pt-BR' }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-bold">Ensino Fundamental - anos finais</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasEnsinoFundamentalAnosFinais | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasDiurnoEnsinoFundamentalAnosFinais | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasIntegralEnsinoFundamentalAnosFinais | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ porcentagemIntegralEnsinoFundamentalAnosFinais }}</td>
              <td class="right-cell align-left text-body-lg text-bold">{{ totalMatriculasNoturnoEnsinoFundamentalAnosFinais | number:'1.0-0':'pt-BR' }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-bold">Ensino Médio</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasEnsinoMedio | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasDiurnoEnsinoMedio | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasIntegralEnsinoMedio | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ porcentagemIntegralEnsinoMedio }}</td>
              <td class="right-cell align-left text-body-lg text-bold">{{ totalMatriculasNoturnoEnsinoMedio | number:'1.0-0':'pt-BR' }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-bold">EJA</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasEja | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasDiurnoEja | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ totalMatriculasIntegralEja | number:'1.0-0':'pt-BR' }}</td>
              <td class="align-left text-body-lg text-bold">{{ porcentagemIntegralEja }}</td>
              <td class="right-cell align-left text-body-lg text-bold">{{ totalMatriculasNoturnoEja | number:'1.0-0':'pt-BR' }}</td>
            </tr>

            <tr class="cells-row">
              <td class="bottom-left-cell align-left text-body-lg text-bold total-row-cell">Total</td>
              <td class="bottom-cell align-left text-body-lg text-bold total-row-cell">{{ totalGeralMatriculas | number:'1.0-0':'pt-BR' }}</td>
              <td class="bottom-cell align-left text-body-lg text-bold total-row-cell">{{ totalGeralDiurno | number:'1.0-0':'pt-BR' }}</td>
              <td class="bottom-cell align-left text-body-lg text-bold total-row-cell">{{ totalGeralIntegral | number:'1.0-0':'pt-BR' }}</td>
              <td class="bottom-cell align-left text-body-lg text-bold total-row-cell">{{ porcentagemIntegralGeral }}</td>
              <td class="bottom-right-cell align-left text-body-lg text-bold total-row-cell">{{ totalGeralNoturno | number:'1.0-0':'pt-BR' }}</td>
            </tr>
          </ng-container>
        </app-tabela>

        <!-- Tabela original com 3 colunas (feature flag desabilitada) -->
        <app-tabela
          *ngIf="!exibirCrechePorIdade"
          [cabecalhoCustomizado]="true"
          ngSkipHydration
        >
          <ng-container cabecalho>
            <tr class="header-row">
              <th class="top-left-header text-body-lg">Etapa/Modalidade</th>
              <th class="top-header text-body-lg">Número de Matrículas ({{anoCenso}})</th>
              <th class="top-right-header text-body-lg">% Matrículas tempo integral ({{anoCenso}})</th>
            </tr>
          </ng-container>
          
          <ng-container corpo>
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Creche</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasCreche | number:'1.0-0':'pt-BR' }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ porcentagemIntegralCreche }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Pré-escola: 4 e 5 anos</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasPreEscola | number:'1.0-0':'pt-BR' }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ porcentagemIntegralPreEscola }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Ensino Fundamental - anos iniciais</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasEnsinoFundamentalAnosIniciais | number:'1.0-0':'pt-BR' }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ porcentagemIntegralEnsinoFundamentalAnosIniciais }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Ensino Fundamental - anos finais</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasEnsinoFundamentalAnosFinais | number:'1.0-0':'pt-BR' }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ porcentagemIntegralEnsinoFundamentalAnosFinais }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="left-cell align-left text-body-lg text-regular">Ensino Médio</td>
              <td class="align-left text-body-lg text-regular">{{ totalMatriculasEnsinoMedio | number:'1.0-0':'pt-BR' }}</td>
              <td class="right-cell align-left text-body-lg text-regular">{{ porcentagemIntegralEnsinoMedio }}</td>
            </tr>
            
            <tr class="cells-row">
              <td class="bottom-left-cell align-left text-body-lg text-regular">EJA</td>
              <td class="bottom-cell align-left text-body-lg text-regular">{{ totalMatriculasEja | number:'1.0-0':'pt-BR' }}</td>
              <td class="bottom-right-cell align-left text-body-lg text-regular">{{ porcentagemIntegralEja }}</td>
            </tr>
          </ng-container>
        </app-tabela>

      </div>
    </div>
  </div>
</section>